import { z } from 'zod'

export const CRM_EMAIL_ANALYSIS_RESULT_CONTRACT_VERSION = '1.0.0' as const

export const crmEmailAnalysisResultResponseSchema = z.object({
  contract_version: z.literal(CRM_EMAIL_ANALYSIS_RESULT_CONTRACT_VERSION),
  messageId: z.string(),
  proposalId: z.string(),
  sideEffects: z.record(z.unknown()),
}).passthrough()

export type CrmEmailAnalysisResultResponse = z.infer<typeof crmEmailAnalysisResultResponseSchema>
